import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PersonProfileTabStateService {
  private readonly selectedTabs = new Map<string, number>();

  getSelectedTab(personId: string): number {
    return this.selectedTabs.get(personId) ?? 0;
  }

  setSelectedTab(personId: string, tabIndex: number): void {
    if (personId) this.selectedTabs.set(personId, tabIndex);
  }
}
